<template lang="html">
    <div class="toast" @click="$emit('close')">
      <p>{{message}}</p>
      <button v-if="action && actionLabel" type="button" @click="handleAction">{{actionLabel}}</button>
      <TodoIcon class="closeButton" :icon="'close'"/>
    </div>
</template>

<script>

import TodoIcon from '@/components/TodoIcon.vue';

export default {
  components: {
    TodoIcon,
  },
  beforeDestroy() {
    if (this.timeoutId) this.timeoutId = window.clearTimeout(this.timeoutId);
  },
  created() {
    if (this.timeout > -1) {
      this.timeoutID = window.setTimeout(() => this.$emit('close'), this.timeout);
    }
  },
  data() {
    return {
      timeoutID: null,
    };
  },
  methods: {
    handleAction() {
      this.action();
    },
  },
  props: {
    action: Function,
    actionLabel: String,
    message: {
      type: String,
      default: 'No message',
    },
    timeout: {
      type: Number,
      default: -1,
    },
  },
};

</script>

<style lang="stylus" scoped>

.toast
  filter: drop-shadow(2px 2px 8px rgba(67, 249, 206, 1))

  p
    padding-right: 30px
    padding-left: 30px
    font-size: 16px !important

  .closeButton
    margin-right: 40px

    >>> .icon
      width: 15px
      height: 15px

  button
    .actionLabel
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      font-size: 16px
      text-transform: uppercase

</style>
